<template>
  <h1>{{ tn("h1Heading") }}</h1>
  <div class="mb"><svg-icon-component icon="logo-allstate" /></div>
  <h2 v-if="justSet" class="mb">{{ tn("subtitle") }}</h2>
  <p>{{ tn("summaryText") }}</p>
  <div v-if="displayManageButton" class="mb">
    <button id="btn-goToAllstate" class="btn-primary" @click="goToAllstate()">{{ tn("goToIDP") }}</button>
  </div>
  <p v-if="displayUpgrade">{{ tn("upgradeText") }}</p>
  <div v-if="displayUpgrade" class="mb">
    <button id="btn-goToAllstate" class="btn-outline-primary" @click="goToUpgradeOptions()">
      {{ tn("viewUpgradeOptions") }}
    </button>
  </div>
</template>
<script lang="ts">
import { defineComponent, onBeforeMount, PropType, computed } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import SvgIconComponent from "@/components/shared/SvgIcon/SvgIcon.vue";
import { IAllstateResponse } from "@/common/api/unifiedPortal/interfaces";
import { listFeaturesAfterSetUp } from "./features";
import { getUrl } from "@/common/getUrl";
import { addOns } from "@/common/webrootProductName";
import { handleApiError } from "@/common/handleApiError";
import { unifiedApi } from "@/common";
import { AxiosError } from "axios";
import { FLAGS } from "@/define";

const componentName = "AllstateAlreadySignedUpComponent";
export default defineComponent({
  name: componentName,
  components: {
    SvgIconComponent,
  },
  props: {
    subscriptions: {
      type: Object as PropType<IAllstateResponse[]>,
      required: false,
      default: null,
    },
    webrootSubscriptionName: {
      type: String,
      required: true,
      default: "",
    },
    webrootSubscriptionSku: {
      type: String,
      required: true,
      default: "",
    },
    isExpired: {
      type: Boolean,
      default: false,
    },
    keycode: {
      type: String,
      required: true,
      default: "",
    },
    justSet: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    logEvent("created", componentName);

    const featuresToDisplay = computed(() => {
      const features = listFeaturesAfterSetUp().filter(f => f.types.toString().includes(props.webrootSubscriptionSku));
      return features;
    });

    const subscriptionName = computed(() => props.webrootSubscriptionName);
    const displayManageButton = computed(() => !props.isExpired);
    const displayUpgrade = computed(
      () => FLAGS.DISPLAY_ALLSTATE_UPGRADE === "true" && addOns.includes(props.webrootSubscriptionSku)
    );

    function tn(v: string, params?: Record<string, unknown>): string {
      return t(`${componentName}.${v}`, params);
    }

    function goToAllstate() {
      window.open(getUrl("ALLSTATE_MANAGE_URL"), "_blank");
    }

    async function goToUpgradeOptions() {
      try {
        if (props.keycode) {
          var url = (await unifiedApi.getWebrootRenewUrl(props.keycode)).data.redirectUrl;
          if (url) {
            const key = url.split("=")[1];
            // This URL will be only used here, so no need to add to env files.
            window.open(getUrl("ALLSTATE_UPGRADE_CART").replace("{key}", key), "_blank");
          }
        }
      } catch (error) {
        handleApiError(error as AxiosError, true);
      }
    }

    onBeforeMount(async () => {
      logEvent("mounting", componentName);
    });

    //Expose to template
    return {
      tn,
      goToAllstate,
      featuresToDisplay,
      subscriptionName,
      displayManageButton,
      displayUpgrade,
      goToUpgradeOptions,
    };
  },
});
</script>

<style scoped lang="css">
@import "@/styles/variables.css";
</style>
